import React, {useState} from 'react';
import s from './AddOrUpdateGame.module.css'
import ImageToBase64Library from "../../../../Static/Base64/ImageToBase64Library";
import InputColor from "react-input-color";

const AddOrUpdateGame = ({game,changeData, levels}) => {
    const [checkedLevel, setCheckedLevel] = useState(null);
    const getLevelTitleById = (levelId) =>{
        return levels && levels.length > 0 ? levels.find(level => level.id === levelId)?.title??"" : "";
    }
    return (
        <div className={s.wrapper}>
            {game.id?<div className={s.title}>Изменить игру</div> : <div className={s.title}>Создание новой игры</div>}
            <div className={s.title_field}>Название игры</div>
            <input type="text"
                   className={s.input_box}
                   placeholder={'Название игры'}
                   value={game.title}
                   onChange={(e)=>{
                       changeData({...game, title:e.target.value})
                   }}/>

            <div className={s.title_field}>Описание игры</div>
            <input type="text"
                   className={s.input_box}
                   placeholder={'Описание игры'}
                   value={game.description}
                   onChange={(e)=>{
                       changeData({...game, description:e.target.value})
                   }}/>

            <div className={s.title_field}>Основной цвет</div>
                <InputColor
                    initialValue={game.color}
                    onChange={ (selectColor)=> {
                        console.log('select color', selectColor )
                        changeData({...game, color:selectColor.hex}
                        )}}
                    placement="right"
                />
            <div className={s.title_field}>Лого</div>
            <ImageToBase64Library base64Image={game.icon} setBase64Image={base64=>changeData({...game, icon:base64})} />

            <div className={s.title_field}>Локации</div>
            <ul>
                {game.levels?.length >0 && game.levels.map(levelId=>{
                    return (<li key={`level_${levelId}`}>{getLevelTitleById( levelId)}</li>)
                })}
            </ul>
            {!checkedLevel && <div className={s.localBtn} onClick={()=>setCheckedLevel( game?.levels??[])}>Изменить список локаций</div>}
            {checkedLevel && <div>
                {levels.map(level=>{
                    const isChecked = !!checkedLevel.find(t=>t === level.id);
                    return (<div key={`level_select_${level}`} onClick={()=>{
                        const newCheckList = isChecked? checkedLevel.filter(t=>t !== level.id) : [...checkedLevel, level.id];
                        setCheckedLevel([...newCheckList]);
                    }}> <span>{isChecked?"V":"X"}</span> {level.title}</div>)
                })}
                {checkedLevel?.length >0?
                    <div className={s.localBtn} onClick={()=>{
                        const newList =  game.levels?.length > 0? [...checkedLevel]: [...game.levels, ...checkedLevel]
                        changeData({...game, levels:newList});
                        setCheckedLevel(null)
                    }}>Обновить</div>:<></>
                }
                <div className={s.localBtn} onClick={()=>setCheckedLevel(null)}>Отмена</div>

            </div>}

        </div>
    );
};

export default AddOrUpdateGame;